import React from "react";
import LandingPage from "./components/LandingPage";
import TermsPage from "./components/TermsPage";
import PrivacyPage from "./components/PrivacyPage";
import CollaborationInviteAccept from "./components/CollaborationInviteAccept";
import BlogPage from "./components/BlogPage";

const App = () => {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";

  if (path.startsWith("/terms")) {
    return <TermsPage />;
  }

  if (path.startsWith("/privacy")) {
    return <PrivacyPage />;
  }

  if (path.startsWith("/blog")) {
    return <BlogPage />;
  }

  if (path.startsWith("/collaboration/invite")) {
    return <CollaborationInviteAccept />;
  }

  return <LandingPage />;
};

export default App;
